/* Keep Loop's native login delivery and validation; add the approved visual shell. */
(()=>{
 if(!location.pathname.includes('/a/loop_subscriptions/get-subscription-link'))return;
 const main=document.querySelector('main');if(!main)return;
 document.body.classList.add('lr-subscription109-page');
 let scheduled=false;
 const sync=()=>{
  scheduled=false;
  const root=main.querySelector('#loop'),body=root?.querySelector('.loop-customer-portal-body'),container=body?.parentElement;
  if(!container)return;
  root.classList.add('lr-subscription109');
  if(!document.querySelector('[data-lr-sub-intro109]')){
   const intro=document.createElement('header');intro.dataset.lrSubIntro109='';
   intro.innerHTML=(window.lrT&&window.lrT["your_little_rick_account_your_8d34"]||'<p class="eyebrow">YOUR LITTLE RICK ACCOUNT.</p><h1>Your subscription.<br>Your way.</h1><p>Pause, skip or change your deliveries in your subscription portal.</p><div class="lr-subscription-badges109"><span>Skip a delivery</span><span>Swap your favorites</span><span>Pause anytime</span></div>');
   const help=document.createElement('a');help.className='text-link';help.href=location.hostname==='littlerick.co.uk'?'/pages/contact-us':'/pages/contact';help.textContent=(window.lrT&&window.lrT["need_a_hand_864a"]||'Need a hand?');intro.append(help);container.prepend(intro);
  }
  const heading=body.querySelector('.loop-h2');if(heading){heading.setAttribute('role','heading');heading.setAttribute('aria-level','2');}
  const input=body.querySelector('input[type=email]');if(input){
   if(!input.id)input.id='lr-subscription-email109';
   const error=body.querySelector('.text-danger');
   if(error&&error.textContent.trim()){
    if(!error.id)error.id='lr-subscription-email-error206';
    error.setAttribute('role','alert');
    input.setAttribute('aria-invalid','true');
    const described=new Set((input.getAttribute('aria-describedby')||'').split(/\s+/).filter(Boolean));described.add(error.id);input.setAttribute('aria-describedby',[...described].join(' '));
   }else{
    input.removeAttribute('aria-invalid');
    const described=(input.getAttribute('aria-describedby')||'').split(/\s+/).filter(id=>id&&id!=='lr-subscription-email-error206');
    if(described.length)input.setAttribute('aria-describedby',described.join(' '));else input.removeAttribute('aria-describedby');
   }
   input.setAttribute('autocomplete','email');input.setAttribute('aria-label',(window.lrT&&window.lrT["email_address_c94d"]||'Email address'));input.setAttribute('placeholder',(window.lrT&&window.lrT["you_example_com_50e2"]||'you@example.com'));
   if(!body.querySelector('[data-lr-sub-label109]')){const label=document.createElement('label');label.dataset.lrSubLabel109='';label.htmlFor=input.id;label.textContent=(window.lrT&&window.lrT["email_address_c94d"]||'Email address');input.before(label);}
  }
 };
 const observer=new MutationObserver(()=>{if(!scheduled){scheduled=true;requestAnimationFrame(sync);}});
 observer.observe(main,{childList:true,subtree:true});sync();window.addEventListener('pagehide',()=>observer.disconnect(),{once:true});
})();
